export default __webpack_public_path__ + "static/media/026-royal guard.789119da.svg";